// redux/selectors/notifications/notificationsSelectors.ts
import { RootState } from "../../storeTypes";
import { NotificationPreferenceDTO } from "../../../types/notifications/notificationsTypes";

/** Full notifications slice (if you ever need raw access) */
export const selectNotificationsState = (state: RootState) => state.notifications;

/** List of notifications (newest first, capped to MAX_ITEMS) */
export const selectNotifications = (state: RootState) => state.notifications.items;

/** Loading flag for list / pagination */
export const selectNotificationsLoading = (state: RootState) => state.notifications.loading;

/** Last error (if any) */
export const selectNotificationsError = (state: RootState) => state.notifications.error;

/** Unread count (badge) */
export const selectNotificationsUnread = (state: RootState) => state.notifications.unread;

/** Whether WS binding for notifications is already done */
export const selectNotificationsWsBound = (state: RootState) => state.notifications.wsBound;

/** Current loaded page index (1-based, 0 = nothing loaded yet) */
export const selectNotificationsPage = (state: RootState) => state.notifications.page;

/** Whether there are more pages on server AND we are under MAX_ITEMS cap */
export const selectNotificationsHasMore = (state: RootState) => state.notifications.hasMore;

/** Total notifications count reported by backend (optional) */
export const selectNotificationsTotal = (state: RootState) => state.notifications.total;

/** How many notifications are currently in memory */
export const selectNotificationsCount = (state: RootState) => state.notifications.items.length;


// List of preferences
export const selectNotificationPreferences = (state: RootState) =>
  state.notifications.preferences;

// Loading flag for preferences
export const selectNotificationPreferencesLoading = (state: RootState) =>
  state.notifications.prefLoading;

// Error for preferences
export const selectNotificationPreferencesError = (state: RootState) =>
  state.notifications.prefError;


export const selectNotificationPreferencesGrouped = (state: RootState) => {
  const prefs = state.notifications.preferences;
  const groups: Record<string, NotificationPreferenceDTO[]> = {};

  prefs.forEach((p) => {
    if (!groups[p.category]) groups[p.category] = [];
    groups[p.category].push(p);
  });

  return groups;
};
